import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from "react-router-dom";
import { getUserRole } from "@utils/auth";
var ProtectedRoute = function (_a) {
    var allowedRoles = _a.allowedRoles;
    var userRole = getUserRole();
    console.log("ProtectedRoute : ", userRole);
    console.log(allowedRoles);
    if (!userRole)
        return _jsx(Navigate, { to: "/login" });
    if (!allowedRoles.includes(userRole))
        return _jsx(Navigate, { to: "/unauthorized" });
    return _jsx(Outlet, {});
};
export default ProtectedRoute;
